import { createAction, props } from '@ngrx/store';

import { ITimezone } from '@interfaces/timezones.interface';

export const loadTimezones = createAction('[Timezones] Load timezones');

export const loadTimezonesSuccess = createAction(
  '[Timezones] Load timezones success',
  props<{ timezones: ITimezone[] }>(),
);

export const loadTimezonesError = createAction(
  '[Timezones] Load timezones error',
  props<{ error: unknown }>(),
);
